import { useNavigate } from "react-router-dom";
import { Card, Icon, Grid, Header } from "semantic-ui-react";

const HomePageCard = props => {
    const navigate = useNavigate()
    return <Card style={{ minHeight: "8rem", margin: "1rem", }} fluid
        header={<div style={
            {
                fontSize: "1.3rem",
                fontWeight: "bold",
                color: "black",
                display: "flex",
                justifyContent: "space-between"
            }
        }>
            <div>{props.header}</div>
            <Icon color="grey" className={props.icon} />
        </div>}
        description={props.description}
        onClick={() =>{
          if(props.href.startsWith("http")){
            window.open(props.href, "_blank", "noopener, noreferrrer")
        }else{
            navigate(props.href)
        }}

    } />
}

const hide_utility_strike = process.env.REACT_APP_SHOW_UTILITY_STRIKE;

export const Forms = () => {
    return (
        <div className="homepage">
            <Header as='h2'>ICC Tool Forms</Header>
            <Grid style={{ width: "70%" }} stackable>

                <Grid.Row>
                    {hide_utility_strike === "true" && (
                        <Grid.Column width={8}>
                            <HomePageCard header="Utility Strike" icon="user" href="/forms/utilitystrike"
                                description="View, edit and delete utility strike forms."
                            />
                        </Grid.Column>
                    )}
                    <Grid.Column width={8}>
                        <HomePageCard header="JSA" icon="user" href="/forms/jsaform"
                            description="View, edit and delete JSA forms."
                        />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <HomePageCard header="Roadblock Form" icon="warning circle" href="/forms/roadblock"
                            description="Report production delays or project issues and track them to resolution."
                        />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <HomePageCard header="Questions Form" icon="question circle" href="/forms/questions"
                            description="Submit questions to leadership and track responses."
                        />
                    </Grid.Column>
                   <Grid.Column width={8}>
                        <HomePageCard header="Attendance Line Form" href={process.env.REACT_APP_ATTENDANCE_FORM_URL}
                            description="Field Service Leave Request."
                        />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <HomePageCard header="Values in Practice (VIP) Recognition" icon="star" href={process.env.REACT_APP_VIP_RECOGNITION_FORM_URL}
                            description="Submit a Values in Practice (VIP) Recognition form."
                        />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <HomePageCard header="Asset Problem" href="/assets?problem=true"
                            description="Report a problem for an asset."
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    )
}